import Fetching from "@/components/Fetching/Fetching";
import { CheckCircle2, CircleX } from "lucide-react";

import classes from "./integration.module.scss";
import IntegrationSyncMessage from "./IntegrationSyncMessage";

const IntegrationOC = ({ completeOrder, hasError = false, messageLines = [], messageOrder = "", text = "Ordenes de Compra" }) => {
	const contentClassName = [classes.content, completeOrder ? classes.complete : classes.inProcess].filter(Boolean).join(" ");
	const lines = messageLines.length > 0 ? messageLines : messageOrder ? [messageOrder] : [];

	return (
		<div className={contentClassName}>
			<div>
				{`Obteniendo ${text}`}
				<IntegrationSyncMessage messageLines={lines} />
			</div>
			<div>
				{!completeOrder && <Fetching topMargin={"0px"} />}
				{completeOrder && !hasError && <CheckCircle2 className={`${classes.checkIcon} ${classes.successIcon}`} />}
				{completeOrder && hasError && <CircleX className={`${classes.checkIcon} ${classes.errorIcon}`} />}
			</div>
		</div>
	);
};

export default IntegrationOC;
